// extracted by mini-css-extract-plugin
export default {"resultsContainer":"resultsContainer---wvJfB","resultsTable":"resultsTable---c7hXL"};